import { motion } from "framer-motion";

// Animated candlestick + trend line motif (decorative, no fake numbers/claims).
export const ChartMotif = ({ className = "" }) => {
  const candles = [
    { x: 8, o: 120, c: 80, h: 70, l: 130, up: true },
    { x: 40, o: 90, c: 110, h: 80, l: 125, up: false },
    { x: 72, o: 110, c: 70, h: 60, l: 120, up: true },
    { x: 104, o: 75, c: 95, h: 65, l: 110, up: false },
    { x: 136, o: 95, c: 55, h: 45, l: 105, up: true },
    { x: 168, o: 60, c: 78, h: 50, l: 90, up: false },
    { x: 200, o: 78, c: 40, h: 32, l: 88, up: true },
    { x: 232, o: 45, c: 30, h: 22, l: 60, up: true },
  ];

  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true">
      <svg viewBox="0 0 260 160" fill="none" className="w-full h-full">
        {/* baseline grid */}
        {[40, 80, 120].map((y) => (
          <line key={y} x1="0" y1={y} x2="260" y2={y} stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        ))}
        {/* candles */}
        {candles.map((c, i) => {
          const color = c.up ? "#C5A059" : "rgba(244,244,240,0.35)";
          const top = Math.min(c.o, c.c);
          const bh = Math.abs(c.o - c.c);
          return (
            <motion.g
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.06 * i, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            >
              <line x1={c.x + 8} y1={c.h} x2={c.x + 8} y2={c.l} stroke={color} strokeWidth="1.5" />
              <rect x={c.x} y={top} width="16" height={Math.max(bh, 3)} fill={color} rx="1" />
            </motion.g>
          );
        })}
        {/* trend line */}
        <motion.path
          d="M8 118 L40 100 L72 92 L104 88 L136 74 L168 66 L200 52 L240 36"
          stroke="#DDB86D"
          strokeWidth="1.5"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.8, ease: "easeInOut" }}
        />
        <motion.circle
          cx="240"
          cy="36"
          r="3.5"
          fill="#DDB86D"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 1.6 }}
        />
      </svg>
    </div>
  );
};

// Slim scrolling ticker of trading concepts (no numbers/claims — themed labels)
export const Ticker = () => {
  const items = [
    "RISK MANAGEMENT",
    "PROCESS",
    "PATIENCE",
    "PREPARATION",
    "PSYCHOLOGY",
    "DISCIPLINE",
    "CLARITY",
    "CONVICTION",
  ];
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-ink-soft/60 py-3" data-testid="trading-ticker">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center font-mono text-xs tracking-[0.25em] text-ash px-6">
            <span className="mr-6 h-1.5 w-1.5 rotate-45 bg-gold" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};
